

export enum AssetStatus
{
	UNKNOWN = 'Unknown',
	OPERATIONAL = 'Operational',
}

